var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form',{attrs:{"label-width":"100px"}},[_c('el-form-item',{attrs:{"label":"关联槽值："}},[_c('el-transfer',{ref:"transfer",attrs:{"filterable":"","filter-placeholder":"请输入槽值","props":{
        key: 'id',
        label: 'slot_name',
      },"titles":['未关联', '已关联'],"value":_vm.combineSlot,"data":_vm.slotList},on:{"change":_vm.handleChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }